module.exports = __webpack_public_path__ + "img/39_45.2a4f2f84.png";